import { TYPE } from '../Analytics/AnalyticsConstants';
import * as AnalyticsConstants from '../Analytics/AnalyticsConstants';
import { ComponentAttributesInterface, ComponentInfoInterface, ComponentInterface } from '../Analytics/AnalyticsTypes';
import { itemInfoEvent } from '../models/Analytics/items';
import { TABLETS, WATCHES } from './constants';

export const trackNewDatalayerEvent = (event: string, eventName: string, eventInfo?: any): void => {
  window.dataLayer.push({
    event: event,
    event_name: eventName,
    ...eventInfo
  });
};

export const ecommerceEmptyDatalayer = (): void => {
  try {
    window.dataLayer.push({ ecommerce: null });
  } catch {
    // ignore push failures when dataLayer is unavailable
  }
};

let ComponentArray: any;

declare global {
  interface Window {
    // analytics object getting binding as a global variable to the window object
    appEventData: any;
    dataLayer: any;
  }
}

//new datalayer tracking
export const trackGADatalayerEvent = (event: string, eventName: string, eventInfo?: any): void => {
  window.dataLayer.push({
    event: event,
    event_name: eventName,
    ...eventInfo
  });
};
interface LineCheckEventInfoInterface {
  address: string;
  eventAction: string;
  eventValue: string | number;
  id: string | undefined;
  timeStamp: number;
  type: string;
}

export const trackLineEvent = (
  address: string,
  eventAction: string,
  eventValue: string | number,
  id: string | undefined,
  type: string
): void => {
  const eventInfo: LineCheckEventInfoInterface = {
    address: address,
    eventAction: eventAction,
    eventValue: eventValue,
    id: id,
    timeStamp: Math.round(Date.now() / 1000),
    type: type
  };
  try {
    window.appEventData.push({
      event: type,
      eventInfo: eventInfo
    });
  } catch {
    //
  }
};

//events tracking
export const trackEvent = (
  eventAction: string,
  eventValue: string | number,
  type: string
): void => {
  const eventInfo: any = {
    eventAction: eventAction,
    eventValue: eventValue,
    timeStamp: Math.round(Date.now() / 1000),
    type: type
  };
  if (type == 'dropDownClick/enter/leftClick') {
    type = TYPE;
  }
  try {
    if (type == 'view') {
      ComponentArray = [];
      window.appEventData.push({
        event: type,
        eventInfo: eventInfo,
        component: ComponentArray
      });
    } else {
      window.appEventData.push({
        event: type,
        eventInfo: eventInfo
      });
    }
  } catch {
    //
  }
};

//messageEvent track
export const trackMessageEvent = (
  description: string,
  source: string,
  title: string,
  type: string,
  guid?: string,
  errorID?: string
): void => {
  const eventInfo: any = {
    description: description,
    source: source,
    title: title,
    type: type,
    guid: guid,
    errorID: errorID
  };
  if (type == 'dropDownClick/enter/leftClick') {
    type = TYPE;
  }
  try {
    const { guid, errorID, ...validationmessage } = eventInfo;
    if (
      (type == 'error' && guid == undefined && errorID == undefined) ||
      type == 'success' ||
      type == 'general'
    ) {
      window.appEventData.push({
        event: 'message',
        message: validationmessage
      });
    } else if (guid !== undefined && errorID !== undefined) {
      window.appEventData.push({
        event: 'message',
        message: eventInfo
      });
    }
  } catch {
    //
  }
};

export interface ErrorEventInfoInterface {
  message_type: string;
  message_title: string;
  message_source: string;
  message_reason: string;
  message_guid?: string;
}
//new datalayer error Event track
export const trackErrorEvent = (
  message_type: string,
  message_title: string,
  message_source: string,
  message_reason: string,
  message_guid?: string
): void => {
  const eventInfo: ErrorEventInfoInterface = {
    message_type: message_type,
    message_title: message_title,
    message_source: message_source,
    message_reason: message_reason,
    message_guid: message_guid
  };
  try {
    if (message_guid !== undefined) {
      window.dataLayer.push({
        event: 'gaEvent',
        event_name: 'error_event',
        ...eventInfo
      });
    } else {
      // const { message_type, message_title, message_source, message_reason } = eventInfo;
      const validationmessage = { message_type, message_title, message_source, message_reason };
      window.dataLayer.push({
        event: 'gaEvent',
        event_name: 'error_event',
        ...validationmessage
      });
    }
  } catch {
    //
  }
};

export interface DataLayerErrorEvent {
  event: string;
  event_name: string;
  message_guid: string;
  message_reason: string;
  message_source: string;
  message_title: string;
  message_type: string;
  message_apiinfo: string;
}

export const errorTrackingDataLayer = (response: any): void => {
  const code: string = (response?.data && response?.data?.code) ?? response?.status;
  const message: string = (response?.data && response?.data?.message) ?? response?.statusText;
  const id: string = (response?.data && response?.data?.id) ?? '';
  const supplierCode: string = (response?.data && response?.data?.supplierCode) ?? '';
  let endPoint = '';
  try {
    endPoint = response?.request?.responseURL;
    endPoint = endPoint?.split('/')?.slice(5)?.join('-');
  } catch (err: any) {
    // eslint-disable-next-line no-console
    console.log('Error while formatting aPI', err);
  }

  const dataLyerErrorLog: DataLayerErrorEvent = {
    event: 'gaEvent',
    event_name: 'error_event',
    message_guid: code,
    message_reason: `MSA: ${message}`,
    message_source: `fixnet | ${endPoint}`,
    message_title: 'Api errror',
    message_type: 'Error',
    message_apiinfo: `${id} | ${supplierCode}`
  };

  try {
    window.dataLayer.push(dataLyerErrorLog);
  } catch (err: any) {
    // eslint-disable-next-line no-console
    console.log('Error while inserting into datalayer', err);
  }
};

export interface UserInterface {
  loginType: string;
  accountID?: string;
  language?: string;
  lastLoginDate?: string;
  type?: string;
  existingUser?: boolean;
}

export const trackUser = (
  loginType: string,
  accountID?: string,
  language?: string,
  lastLoginDate?: string,
  type?: string,
  existingUser?: boolean
): void => {
  try {
    if (!accountID || !language || !lastLoginDate || !type || !existingUser) {
      const user: UserInterface = {
        loginType: loginType
      };
      window.appEventData.push({
        user: user
      });
    } else {
      const user: UserInterface = {
        loginType: loginType,
        accountID: accountID,
        language: language,
        lastLoginDate: lastLoginDate,
        type: type,
        existingUser: existingUser
      };
      window.appEventData.push({
        user: user
      });
    }
  } catch {
    //
  }
};

//US 349849
export const trackViewItem = (event: string, eventName: string, product: any): void => {
  const variantColor = product?.variant;
  const variantSize = product?.storage;
  const item_variant =
    (variantColor || '') +
    (variantColor && variantSize ? '|' : '') +
    (variantSize || '');

  const itemData: itemInfoEvent = {
    item_id: product?.productId?.replace(/^0+/, ''),
    item_name: product?.displayName,
    affiliation: '',
    coupon: '',
    discount: 0,
    index: product.index,
    item_brand: AnalyticsConstants.BRAND,
    item_category: AnalyticsConstants.ACCESSORYCATEGORY,
    item_category2: '',
    item_category3: '',
    item_category4: '',
    item_category5: '',
    item_list_id: AnalyticsConstants.ACCESSORYLISTNAME,
    item_list_name: AnalyticsConstants.ACCESSORYLISTNAME,
    item_variant: item_variant,
    location_id: '',
    price: product?.priceValue,
    promotion_id: '',
    quantity: 1,
    item_available: 'yes'
  };
  if(product?.hardwareCategory === TABLETS || product?.hardwareCategory === WATCHES){
    itemData.item_category = AnalyticsConstants.HARDWARE,
    itemData.item_category2 = AnalyticsConstants.ACCESSORYCATEGORY
  }
  itemData &&
    window.dataLayer.push({
      event: event,
      event_name: eventName,
      ecommerce: {
        currency: 'CHF',
        value: product?.priceValue,
        items: [{ ...itemData }]
      }
    });
};
//mmc tracking
export const setMmcItemTracker = (productList: any) => {
  const itemData: itemInfoEvent[] = productList.map((product: any) => {
    const variantColor = product?.variant;
    const variantSize = product?.storage;
    const item_variant =
      (variantColor || '') +
      (variantColor && variantSize ? '|' : '') +
      (variantSize || '');
    return {
      item_id: product?.productId?.replace(/^0+/, ''),
      item_name: product?.displayName,
      affiliation: '',
      coupon: '',
      discount: 0,
      index: product.index,
      item_brand: AnalyticsConstants.BRAND,
      item_category: AnalyticsConstants.ACCESSORYCATEGORY,
      item_category2: '',
      item_category3: '',
      item_category4: '',
      item_category5: '',
      item_list_id: AnalyticsConstants.ACCESSORYLISTNAME,
      item_list_name: AnalyticsConstants.ACCESSORYLISTNAME,
      item_variant: item_variant,
      location_id: '',
      price: product?.priceValue,
      quantity: 1
    };
  });
  itemData &&
    window.dataLayer.push({
      event: AnalyticsConstants.VIEWITEM,
      event_name: AnalyticsConstants.VIEWITEM,
      ecommerce: {
        item_list_id: AnalyticsConstants.ACCESSORYLISTNAME,
        item_list_name: AnalyticsConstants.ACCESSORYLISTNAME,
        items: [...itemData]
      }
    });
};

//components tracking
export const trackComponent = (
  title: string,
  targetLink: string,
  type: string,
  subType: string
): void => {
  const attributes: ComponentAttributesInterface = {
    title: title,
    targetLink: targetLink
  };
  const componentInfo: ComponentInfoInterface = {
    type: type,
    subType: subType
  };
  const component: ComponentInterface = {
    componentInfo: componentInfo,
    attributes: attributes
  };
  ComponentArray?.push(component);
};